import { render, staticRenderFns } from "./RulesTable.vue?vue&type=template&id=24ef1077&scoped=true&"
import script from "./RulesTable.vue?vue&type=script&lang=js&"
export * from "./RulesTable.vue?vue&type=script&lang=js&"
import style0 from "./RulesTable.vue?vue&type=style&index=0&id=24ef1077&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ef1077",
  null
  
)

export default component.exports